import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { CategoriaProducto } from './categoria-producto.model';

@Injectable()
export class CategoriaProductoResolver implements Resolve<CategoriaProducto> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        return this.backendService.new(CategoriaProducto);
      }
      return await this.backendService.get(CategoriaProducto, CategoriaProducto.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/categorias']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/categoria-producto/categoria-producto.resolver.ts